<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: SiteFooter                                            |
| Section: components                                              |
| Purpose: Global footer with navigation links and attribution.    |
+------------------------------------------------------------------+
-->
<template>
    <footer>
        <ul class="row wrapper">
            <li class="col">
                <h3>Sejarah Thümann</h3>
                <p>{{ $t('siteFooter.familyHistory') }}</p>
                <p>{{ $t('siteFooter.credit') }}</p>
                <p>© 2021-{{ currentYear }}</p>
            </li>
            <li class="col">
                <h3>{{ $t('siteFooter.contact') }}</h3>
                <ul class="socials">
                    <li>
                        <BtnIcon iconName="email" :href="localePath('/contact')" />
                    </li>
                    <li>
                        <BtnIcon iconName="whatsapp" href="https://wa.me/31642454580" />
                    </li>
                </ul>
            </li>
            <li class="col">
                <h3>{{ $t('siteFooter.quickLinks') }}</h3>
                <router-link :to="localePath('/')">{{ $t('siteFooter.links.home') }}</router-link>
                <router-link :to="localePath('/stamboom?view=achternamen')">{{
                    $t('siteFooter.links.surnames') }}</router-link>
                <router-link :to="localePath('/stamboom')">{{ $t('siteFooter.links.peopleNetwork') }}</router-link>
                <router-link :to="localePath('/stamboom?view=relaties')">{{
                    $t('siteFooter.links.familyMembers') }}</router-link>
                <router-link :to="localePath('/verhalen')">{{ $t('siteFooter.links.stories') }}</router-link>
                <router-link :to="localePath('/nieuw')">{{ $t('siteFooter.links.recentFinds') }}</router-link>
                <router-link :to="localePath('/fotos-en-documenten')">{{ $t('siteFooter.links.media') }}</router-link>
                <router-link :to="localePath('/plaatsen')">{{ $t('siteFooter.links.places') }}</router-link>
                <router-link :to="localePath('/gezocht')">{{ $t('siteFooter.links.research') }}</router-link>
                <router-link :to="localePath('/dna')">{{ $t('siteFooter.links.dnaMatches') }}</router-link>
                <router-link :to="localePath('/kalender')">{{ $t('siteFooter.links.calendar') }}</router-link>
                <router-link :to="localePath('/statistieken')">{{ $t('siteFooter.links.stats') }}</router-link>
                <router-link :to="localePath('/over')">{{ $t('siteFooter.links.about') }}</router-link>
                <router-link :to="localePath('/contact')">{{ $t('siteFooter.links.contact') }}</router-link>
            </li>
            <li class="col">
                <h3>{{ $t('siteFooter.references') }}</h3>
                <a href="https://www.archieven.nl/nl/" target="_blank">Archieven.nl<img
                        src="@/assets/icons/external.svg"></a>
                <a href="https://cbg.nl/" target="_blank">Centraal Bureau voor Genealogie<img
                        src="@/assets/icons/external.svg"></a>
                <a href="https://www.delpher.nl/" target="_blank">Delpher<img src="@/assets/icons/external.svg"></a>
                <a href="https://www.familysearch.org/" target="_blank">FamilySearch<img
                        src="@/assets/icons/external.svg"></a>
                <a href="https://igv.nl/" target="_blank">Indische Genealogische Vereniging<img
                        src="@/assets/icons/external.svg"></a>
                <a href="https://www.nationaalarchief.nl/" target="_blank">Nationaal Archief<img
                        src="@/assets/icons/external.svg"></a>
                <a href="https://www.roosjeroos.nl/" target="_blank">Roosje Roos<img
                        src="@/assets/icons/external.svg"></a>
            </li>
        </ul>
    </footer>
</template>

<script>
import BtnIcon from '@/atoms/BtnIcon.vue';
import { useLocale } from '@/composables/useLocale';

export default {
    name: 'SiteFooter',
    components: {
        BtnIcon
    },
    setup() {
        const { localePath } = useLocale();
        return { localePath };
    },
    data() {
        return {
            currentYear: new Date().getFullYear()
        };
    }
};
</script>

<style scoped>
footer {
    background: var(--brand-bg-4);
    color: var(--brand-text-light);
    padding: 144px 0;
}

.row {
    display: flex;
    flex-direction: row;
    gap: 48px;
    padding: 0 20px
}

.col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
}

.socials {
    display: flex;
    flex-direction: row;
    gap: 8px;
}

a {
    color: var(--brand-text-light);
}

a:hover:not(BtnIcon) {
    text-decoration: underline;
}

@media (max-width: 720px) {
    footer {
        padding: 72px 0;
    }

    .row {
        flex-direction: column;
    }
}
</style>
